import { PartnerPracticeApi } from '@/api/partner-practice';
import { State } from '@/stores/partner-practices/state';
import { ActionContext, ActionTree } from 'vuex';

const partnerPracticeApi = new PartnerPracticeApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public loadPartnerPracticesAsync = async (context: ActionContext<State, any>) => {
        const response = await partnerPracticeApi.getPartnerPracticesAsync();
        context.commit('setPartnerPractices', response.partnerPractices);
    }
}
